import React, { Component } from "react";
import Logo from "../../../shared/logo";
import SignInFooter from "../../../shared/footer/signinFooter";

import styles from "./restorePassword.module.scss";
import { withRestore } from "../../../shared/containers/containerRestore";
import { states } from "../../../reducers/queriesStates";
import RestorePasswordForm from "./RestorePasswordForm";
import ButtonRestorePasswordWrapper from "./ButtonRestorePasswordWrapper";

let interval = null;

class RestorePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      timoutLinkMessage: null,
      restoreCompleted: null,
      count: 3,
    };
  }

  componentDidMount() {
    const { onGetRestoreData, onHandleChangeStore } = this.props;
    const token = window.location.search.replace("?token=", "");

    onHandleChangeStore("token", token);
    onGetRestoreData({ token });
  }

  componentDidUpdate(prevProps) {
    const { restore } = this.props;

    if (restore.getRestoreDataState === states.FAILURE && prevProps.restore.getRestoreDataState === states.REQUEST) {
      this.setState({ timoutLinkMessage: restore.errors });
    }

    if (restore.dataState === states.READY && prevProps.restore.dataState === states.REQUEST) {
      const toSignIn = () => {
        const { count } = this.state;
        if (count === 0) {
          clearInterval(interval);
          window.open(window.location.origin, "_self");
        } else {
          this.setState({ count: count - 1, restoreCompleted: `Переход на страницу входа ${count}` });
        }
      };

      interval = setInterval(toSignIn, 1500);
    }
  }

  render() {
    const { restore } = this.props;
    const { timoutLinkMessage, restoreCompleted } = this.state;

    return (
      <div className={styles.restoreWrapper}>
        <div className={styles.restoreForm}>
          <div className={styles.logo_container}>
            <Logo />
          </div>

          {restoreCompleted !== null ? (
            <div className={styles.restoreCompleted}>
              <div>Пароль успешно изменён</div>
              <div>{restoreCompleted}</div>
            </div>
          ) : null}

          {restore.email !== null ? <div className={styles.email}>{restore.email}</div> : null}
          {timoutLinkMessage !== null ? <div className={styles.timoutLinkMessage}>{timoutLinkMessage}</div> : null}

          {restore.email !== null ? <RestorePasswordForm /> : null}

          {restore.email !== null ? (
            <div className={styles.button_container}>
              <ButtonRestorePasswordWrapper />
            </div>
          ) : null}

          <div className={styles.linkSignIn}>
            <a href="/">На страницу входа</a>
          </div>
        </div>

        <SignInFooter />
      </div>
    );
  }
}

export default withRestore(RestorePassword);
